module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/224-portugal-f694d3f76b3768c7bc9ef8e051f04836.svg";